// Map a getShow(...) response into the shape used by the show analytics + Year-on-Year
// views (ShowYoYDashboard). Groups per-year country/category rows for YoY comparison.
export function buildShowDetail(s) {
  if (!s) return null;

  const countriesByYear = {};
  (s.top_countries || []).forEach((c) => {
    if (!countriesByYear[c.year]) countriesByYear[c.year] = [];
    countriesByYear[c.year].push({ c: c.country, v: c.count, pct: c.pct_of_total });
  });

  const catByYear = {};
  (s.top_categories || []).forEach((c) => {
    if (!catByYear[c.year]) catByYear[c.year] = [];
    catByYear[c.year].push({ n: c.category_name, v: c.count, pct: c.pct_of_total });
  });

  const latestCY   = Object.keys(countriesByYear).map(Number).sort((a, b) => b - a)[0];
  const latestCatY = Object.keys(catByYear).map(Number).sort((a, b) => b - a)[0];

  return {
    id:           s.show_id,
    name:         s.name,
    ite_event_id: s.ite_event_id,
    location:     s.location,
    startDate:    s.start_date,
    endDate:      s.end_date,
    website:      s.website,
    team:         s.team,
    status:       s.status,
    // An edition that has been scheduled but not yet enriched carries a
    // placeholder row with every stat NULL (written by shows.py on show
    // creation). Dropping those keeps an un-enriched year from reading as an
    // edition with zero exhibitors, and stops a single-year show from looking
    // multi-year and offering a year-on-year view over data that isn't there.
    yearData: (s.yearly_stats || [])
      .filter((y) => y.total !== null && y.total !== undefined)
      .map((y) => ({
        y:          y.year,
        total:      y.total,
        newCo:      y.new_companies,
        returning:  y.returning,
        dropped:    y.dropped,
        countries:  y.country_count,
        categories: y.category_count,
      })),
    topCountries:  countriesByYear[latestCY]  || [],
    topCategories: catByYear[latestCatY]       || [],
    countriesByYear,
    catByYear,
  };
}
